import React from "react";
import { AlertTriangle, DollarSign, Wrench, Phone } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useSummaryDashboard } from "../../hooks";
import { useCurrency, useUserName } from "@shared/selectors/globalSelectors";

export const Dashboard: React.FC = () => {
  const cachedProfile = useUserName();
  const currency = useCurrency();
  const { data: summaryDashboard } = useSummaryDashboard(cachedProfile);
  const getTrendSymbol = (trend: string) => {
    if (trend === "increase") return "+";
    if (trend === "decrease") return "-";
    return "";
  };
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard
        title="Calls Handled Today"
        count={summaryDashboard?.totalCalls?.current || 0}
        trendSummary={`${getTrendSymbol(summaryDashboard?.totalCalls?.trend)}${
          summaryDashboard?.totalCalls?.previous || 0
        } from yesterday`}
        icon={<Phone className="h-8 w-8 text-amber-500" />}
      />
      <QuickStatsCard
        title="Payments Collected"
        count={currency + " " + summaryDashboard?.paymentAmount?.current || 0}
        trendSummary={`${getTrendSymbol(
          summaryDashboard?.paymentAmount?.trend
        )}${summaryDashboard?.paymentAmount?.previous || 0} transactions today`}
        icon={<DollarSign className="h-8 w-8 text-blue-500" />}
      />
      <QuickStatsCard
        title="Service Requests"
        count={summaryDashboard?.serviceRequest?.current || 0}
        trendSummary={`${getTrendSymbol(
          summaryDashboard?.serviceRequest?.trend
        )}${summaryDashboard?.serviceRequest?.previous || 0} completed`}
        icon={<Wrench className="h-8 w-8 text-red-500" />}
      />
      <QuickStatsCard
        title="Total Complaints"
        count={summaryDashboard?.complaintsRegistered?.current || 0}
        trendSummary={`${getTrendSymbol(
          summaryDashboard?.complaintsRegistered?.trend
        )}${summaryDashboard?.complaintsRegistered?.previous || 0} resolved today`}
        icon={<AlertTriangle className="h-8 w-8 text-green-500" />}
      />
    </div>
  );
};
